import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";
import Logout from "./Logout";
import Icon from "./ui/Icon";
import "./Nav.css";

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [accountOpen, setAccountOpen] = useState(false);
  const [cookies] = useCookies(["sessionID"]);
  const accountRef = useRef(null);
  const accountButtonRef = useRef(null);
  const mobileButtonRef = useRef(null);
  const navigationRef = useRef(null);
  const { pathname } = useLocation();
  useEffect(() => {
    setOpen(false);
    setAccountOpen(false);
  }, [pathname]);
  useEffect(() => {
    if (open) navigationRef.current?.querySelector("a")?.focus();
  }, [open]);
  useEffect(() => {
    const close = (event) => {
      if (!accountRef.current?.contains(event.target)) setAccountOpen(false);
    };
    const escape = (event) => {
      if (event.key !== "Escape") return;
      if (accountOpen) {
        setAccountOpen(false);
        accountButtonRef.current?.focus();
      } else if (open) {
        setOpen(false);
        mobileButtonRef.current?.focus();
      }
    };
    document.addEventListener("mousedown", close);
    document.addEventListener("keydown", escape);
    return () => {
      document.removeEventListener("mousedown", close);
      document.removeEventListener("keydown", escape);
    };
  }, [open, accountOpen]);
  return (
    <nav className="ui-nav" aria-label="Main navigation">
      <Link className="ui-brand" to="/" aria-label="KH Workspace home">
        <span className="ui-brand-mark">
          <Icon name="spark" size={23} />
        </span>
        <span>
          kh<span className="ui-brand-dot">.</span>
          <span className="ui-brand-subtitle">workspace</span>
        </span>
      </Link>
      <div
        id="main-navigation"
        ref={navigationRef}
        className={`ui-nav-links ${open ? "is-open" : ""}`}
      >
        <NavLink to="/" end>
          Overview
        </NavLink>
        <NavLink to="/agent-hub">Agent Hub</NavLink>
        <NavLink to="/workflows">Workflows</NavLink>
        <NavLink to="/apps">Apps</NavLink>
        <NavLink to="/paper-trading">Paper trading</NavLink>
        <NavLink to="/about">How it works</NavLink>
      </div>
      <div className="ui-nav-actions">
        <NavLink
          className="ui-icon-button ui-settings-link"
          to="/settings"
          aria-label="Workspace settings"
          title="Workspace settings"
        >
          <Icon name="settings" />
        </NavLink>
        <div className="ui-account" ref={accountRef}>
          <button
            ref={accountButtonRef}
            className="ui-avatar"
            onClick={() => setAccountOpen(!accountOpen)}
            aria-label="Account menu"
            aria-expanded={accountOpen}
            aria-controls="account-navigation"
          >
            KH
          </button>
          {accountOpen && (
            <div className="ui-account-menu" id="account-navigation">
              <span className="ui-menu-label">YOUR WORKSPACE</span>
              <Link to="/settings">
                <Icon name="settings" size={17} /> Settings & connections
              </Link>
              <Link to="/voice-test">
                <Icon name="chat" size={17} /> Voice studio
              </Link>
              <Link to="/write">
                <Icon name="document" size={17} />
                {cookies.sessionID ? "Write an article" : "Sign in"}
              </Link>
              {!cookies.sessionID && <Link to="/register"><Icon name="plus" size={17} /> Create an account</Link>}
              {cookies.sessionID && <Logout />}
            </div>
          )}
        </div>
        <button
          ref={mobileButtonRef}
          className="ui-icon-button ui-mobile-toggle"
          aria-label={open ? "Close navigation" : "Open navigation"}
          aria-expanded={open}
          aria-controls="main-navigation"
          onClick={() => setOpen(!open)}
        >
          <Icon name={open ? "close" : "menu"} />
        </button>
      </div>
    </nav>
  );
}
